import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
  Icon,
  Flex,
  Text,
} from "@chakra-ui/react";
import { FaCaretDown } from "react-icons/fa6";
import {
  newBorder,
  textSecondary,
  backgroundLight,
  greyHover,
  hoverItemColor,
  textPrimary,
} from "../../utils/colors";
import useThemeColors from "../../hooks/useThemeColors";

const DropdownButtonNew = ({
  initialLabel,
  items,
  onSelectItem,
  iconComponent,
  ...menuButtonProps
}) => {
  const { whiteMode, backgroundLightMode } = useThemeColors();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(initialLabel);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const handleMenuItemClick = (item) => {
    onSelectItem(item);
    setSelectedLabel(item); // Update the label with the selected item
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedLabel(initialLabel);
  }, [initialLabel]);

  // console.log("initialLabel", initialLabel);
  // console.log("selectedLabel", selectedLabel);

  return (
    <Box p={0} borderRadius="0.75rem">
      <Menu isLazy onOpen={handleMenuOpen} onClose={handleMenuClose}>
        <MenuButton
          as={Button}
          bg={[backgroundLightMode, backgroundLightMode]}
          color={textSecondary}
          border={`0px solid ${newBorder}`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="10.75rem"
          size={["sm", "sm"]}
          fontSize="xs"
          p="0rem 0.75rem"
          // position="relative"
          // top="0.25rem"
          transition="0.2s all"
          fontWeight="500"
          _hover={{ bg: greyHover }}
          _active={{ bg: backgroundLight }}
          cursor="pointer"
          onClick={() => setIsOpen(!isOpen)}
          {...menuButtonProps}
        >
          <Flex align="center">
            {iconComponent && <Box mr={2}>{iconComponent}</Box>}
            <Text>{selectedLabel}</Text>
            <Icon
              as={FaCaretDown}
              ml={1}
              h="0.75rem"
              w="0.75rem"
              transition="all 0.2s ease"
              transform={isOpen ? "rotate(180deg)" : "rotate(0)"}
            />
          </Flex>
        </MenuButton>
        <MenuList
          p={0}
          m={0}
          borderRadius="1rem"
          maxWidth="100px"
          w="100px"
          overflow="hidden"
        >
          {items.map((item, index) => (
            <MenuItem
              key={index}
              py={[4, 2]}
              px={4}
              borderBottom={`1px solid ${newBorder}`}
              color={textSecondary}
              _hover={{ bg: hoverItemColor, color: textPrimary }}
              onClick={() => handleMenuItemClick(item)}
            >
              <Text fontWeight="500" fontSize="xs">
                {item}
              </Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default DropdownButtonNew;
